export default "__VITE_ASSET__CZD6UDCQ__"